import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
  if (window.location.pathname.includes("confirm-email")) {
    return <Outlet />;
  }
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  if (isAuthenticated) {
    return <Navigate to="/project" replace />;
  }
  return <Outlet />;
};

export default PublicRoute;
